export function openEcommerceSite() {
  window.open(window.location.href.split('/manager')[0], '_blank');
}
